
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en/index";
import fr from "../locales/fr/index";
import ptBr from "../locales/pt-br/index";

// Debug logging to see what's being loaded
console.log("EN translations:", en);
console.log("FR translations:", fr);
console.log("PT-BR translations:", ptBr);
console.log("PT-BR appName:", ptBr.appName);

// Debug the i18n instance
const debugI18n = () => {
  console.log("Current language:", i18n.language);
  console.log("Available languages:", i18n.languages);
  console.log("Current Mappa Caeli translation:", i18n.t("appName"));
  console.log("localStorage language:", localStorage.getItem("language"));
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      "pt-BR": { translation: ptBr },
    },
    lng: localStorage.getItem("language") || "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })
  .then(() => {
    console.log("Mappa Caeli i18n initialized successfully");
    debugI18n();
  });

// Debug on language change
i18n.on('languageChanged', (lng) => {
  console.log("Language changed to:", lng);
  debugI18n();
});

export default i18n;
